import { Compass, Sparkles } from "lucide-react";

import { useMaxwellAccess } from "@/components/maxwell/useMaxwellAccess";
import { useUserPreferences } from "@/hooks/useUserPreferences";

import { ModuleHelperCard } from "./ModuleHelperCard";

/**
 * Preferences → Modules: the helpers that appear inside particular modules,
 * each naming where it lives. Maxwell is listed only for a user who can use
 * it — the feature and the permission together (`useMaxwellAccess`).
 */
export function ModulesSection() {
  const { effective, save, readOnly } = useUserPreferences();
  const maxwell = useMaxwellAccess();

  return (
    <div className="flex flex-col gap-4">
      {maxwell ? (
        <ModuleHelperCard
          icon={Sparkles}
          title="Maxwell assistant panel"
          description="The Maxwell rail beside your work. Closing it from the rail turns this off too; the Maxwell button in the top bar opens it again from anywhere."
          modules={["energy-advisor"]}
          where="beside every Energy Advisor page"
          checked={effective.show_maxwell_panel}
          disabled={readOnly}
          onCheckedChange={(on) => save({ show_maxwell_panel: on })}
        />
      ) : null}
      <ModuleHelperCard
        icon={Compass}
        title="Setup guidance"
        description="Setup checklists that walk a new record to ready, and the next-step card pinned in Maxwell. Hiding one checklist hides them all."
        modules={["energy-advisor", "operations"]}
        where="on client and deal pages"
        checked={effective.show_guidance}
        disabled={readOnly}
        onCheckedChange={(on) => save({ show_guidance: on })}
      />
    </div>
  );
}
